<template>
    <md-field class="custom-chips" :class="[$mdActiveTheme, chipsClasses]">
        <slot/>
        <div style="display:flex; align-items:center;padding: 0.3rem;"><div v-if="!value || value.length===0" style="line-height: 1.2;">{{inputDefaultString}}</div></div>
        <custom-chip v-for="(chip, idx) in value" :key="idx" :md-deletable="!mdStatic" :md-clickable="!mdStatic" :md-duplicated="duplicatedChip === chip[itemText]" @keydown.enter="$emit('md-click', chip, idx)" @click.native="$emit('md-click', chip, idx)" @md-delete.stop="removeChip(chip)">
            <slot name="custom-chip" :chip="chip" v-if="$scopedSlots['md-chip']">
                <input type="hidden" :name="chipsInputName" :value="chip[itemKey]"/>
                <div v-if="!showValueText">{{ (chip[itemText] ? chip[itemText] : '') }}</div>
                <div v-if="showValueText">{{ (chip[itemValueText] ? chip[itemValueText] : '') + ' : ' + (chip[itemText] ? chip[itemText] : '') }}</div>
            </slot>
            <template v-else>
                <input type="hidden" :name="chipsInputName" :value="chip[itemKey]"/>
                <div v-if="!showValueText">{{ (chip[itemText] ? chip[itemText] : '') }}</div>
                <div v-if="showValueText">{{ (chip[itemValueText] ? chip[itemValueText] : '') + ' : ' + (chip[itemText] ? chip[itemText] : '') }}</div>
            </template>
        </custom-chip>
        <div class="custom-chips-input-wrapper col p-0 d-flex" style="border-bottom: 1px solid transparent;">
            <md-input
                    ref="input"
                    class="col"
                    v-model.trim="inputValue"
                    v-if="!mdStatic && modelRespectLimit && !chipsInputDisabled"
                    :type="mdInputType"
                    :id="id"
                    :readonly="chipsInputReadonly"
                    :placeholder="mdPlaceholder"
                    :name="'chips-input-' + chipsInputName"
                    @input="handleInput"
                    @keydown.enter="insertChip"
                    @keydown.8="handleBackRemove">
            </md-input>
            <span class="d-flex align-items-center" style="font-size: 0.63rem;color: initial;">&#9660;</span>
        </div>
    </md-field>
</template>

<script>
    import MdComponent from '../../core/MdComponent'
    import MdField from '../../components/MdField/MdField'
    import MdInput from '../../components/MdField/MdInput/MdInput'
    import MdUuid from '../../core/utils/MdUuid'
    import MdPropValidator from '../../core/utils/MdPropValidator'
    import CustomChip from "./CustomChip"
    import MdDropDownIcon from '../../core/icons/MdDropDownIcon'

    export default new MdComponent({
        name: 'CustomChips',
        components: {
            MdField,
            MdInput,
            CustomChip,
            MdDropDownIcon
        },
        props: {
            selectData: {
                default: () => [{
                    key: "",
                    name: ""
                }],
            },
            // value: {
            //   default: () => [{
            //     key: "",
            //     name: ""
            //   }],
            // },
            id: {
                type: [String, Number],
                default: () => 'md-chips-' + MdUuid()
            },
            mdInputType: {
                type: [String, Number],
                ...MdPropValidator('md-input-type', ['email', 'number', 'password', 'search', 'tel', 'text', 'url'])
            },
            mdPlaceholder: [String, Number],
            mdStatic: Boolean,
            mdLimit: Number,
            mdCheckDuplicated: {
                type: Boolean,
                default: false
            },
            mdFormat: {
                type: Function
            },
            itemKey: {
                type: String,
                default: 'id',
            },
            itemValueText: {
                type: String,
                default: 'value',
            },
            itemText: {
                type: String,
                default: 'name',
            },
            chipsInputReadonly: {
                type: Boolean,
                default: false,
            },
            chipsInputDisabled: {
                type: Boolean,
                default: false,
            },
            chipsInputName: {
                type: String,
                default: 'selectedchips[]'
            },
            showValueText:{
                type: Boolean,
                default: false,
            },
            inputDefaultString: {
                type: String,
                default: '未選択'
            },
        },
        data() {
            return {
                inputValue: '',
                duplicatedChip: null,
                value: this.selectData
            }
        },
        computed: {
            chipsClasses() {
                return {
                    'md-has-value': this.value && this.value.length
                }
            },

            modelRespectLimit() {
                return !this.mdLimit || this.value.length < this.mdLimit
            },

            formattedInputValue() {
                if (!this.mdFormat) {
                    return this.inputValue
                }
                return this.mdFormat(this.inputValue)
            }
        },
        created() {
            for (let i = 0; i < this.selectData.length; i++) {
                let obj = {};
                if (this.selectData[i][this.itemKey]) {
                    obj[this.itemKey] = this.selectData[i][this.itemKey];
                } else {
                    obj[this.itemKey] = this.selectData[i][this.itemText];
                }
                obj[this.itemText] = this.selectData[i][this.itemText];
                this.$set(this.value, i, obj);
            }
        },
        methods: {
            insertChip({target}) {
                let inputValue = this.formattedInputValue;

                if (!inputValue || !this.modelRespectLimit) {
                    return
                }

                if (this.value.findIndex(({name}) => name === inputValue) !== -1) {
                    this.duplicatedChip = null
                    // to trigger animate
                    this.$nextTick(() => {
                        this.duplicatedChip = inputValue
                    })
                    return
                }

                let obj = {};
                obj[this.itemKey] = inputValue;
                obj[this.itemText] = inputValue;

                this.value.push(obj);
                this.$emit('input', this.value);
                this.$emit('md-insert', obj);
                this.inputValue = ''
            },
            removeChip(chip) {
                const index = this.value.findIndex(({name}) => name === chip.name);
                if (index === -1) {
                    return;
                }
                this.value.splice(index, 1);
                this.$emit('input', this.value);
                this.$emit('md-delete', chip, index);
                this.$emit('remove-chip', chip, index);
                this.$nextTick(() => this.$refs.input.$el.focus())
            },
            handleBackRemove() {
                if (!this.inputValue) {
                    this.removeChip(this.value[this.value.length - 1])
                }
            },
            handleInput() {
                if (this.mdCheckDuplicated) {
                    this.checkDuplicated()
                } else {
                    this.duplicatedChip = null
                }
            },
            checkDuplicated() {
                if (!this.value.includes(this.formattedInputValue)) {
                    this.duplicatedChip = null
                    return false
                }

                if (!this.mdCheckDuplicated) {
                    return false
                }

                this.duplicatedChip = this.formattedInputValue
            },
            log(msg, obj = "") {
                console.log(msg, obj);
            }
        },
        watch: {
            value: {
                handler: function () {
                    this.checkDuplicated()
                },
                deep: true
            }
        }
    })
</script>

<style lang="scss">
    @import "../../components/MdAnimation/variables";

    .custom-chips.md-field {
        padding: 0;
        flex-wrap: wrap;
        margin: 0;
        min-height: calc(1.6em + 0rem + 2px);

        .md-chip {
            margin-top: 0.15rem;
            margin-bottom: 0.15rem;
        }

        input {
            padding-left: 4px;
        }

        &.md-has-value {
            label {
                top: -6px;
            }
        }

        .custom-chips {
            margin-bottom: 4px;

            &:last-of-type {
                margin-right: 8px;
            }
        }

        .md-input {
            line-height: 1.2;
            height: auto;
            padding: 0.15rem;
        }

        .md-input:read-only{
            cursor: pointer;
        }
    }
    .custom-chips.md-field:hover {
        cursor: pointer;
    }
</style>
